import React, { FC, useRef, useState } from 'react';
import MaterialIcon from '../../../../shared/common/MaterialIcon';
import { IssueUsageStatisticsCell } from '../../../../shared/subscription-management/IssueUsageStatisticsCell';
import {
    ExtendedManageLineShared,
    ExtendedManageLineUsageLimit
} from '../../../../shared/subscription-management/types/ExtendedManageLineShared';
import { StockDetails } from '../../../../store/api';
import { ProductCopyStockDropdown } from '../../../../shared/product/ProductCopyStock';
import { useTranslation } from 'react-i18next';
import { LOANFORMAT_EPRESS_OBJECT } from '../../../../shared/loanFormat/constants';

export const ExtendedManageSubscriptionSharedRow: FC<ExtendedManageLineShared> = props => {
    const { currentYearSubscription, nextYearSubscription, previousIssueUsage, currentIssueUsage } = props;
    const { t } = useTranslation();
    return (
        <tr className="shared-row">
            <td></td>
            <td className="usage-limit-cell">
                <div>
                    <MaterialIcon icon="shared" primary={false} className="shared-icon" />
                    <b>{t('shop.subscriptions.shared')}</b>
                </div>
            </td>
            <td className="current-year-subscriptions">
                {(() => {
                    switch (currentYearSubscription.type) {
                        case ExtendedManageLineUsageLimit.Value:
                            return (
                                <ExtendedManageLineUsageLimitValue
                                    label={currentYearSubscription.label}
                                    stockDetails={currentYearSubscription.stockDetails}
                                />
                            );
                        case ExtendedManageLineUsageLimit.None:
                            return <small>{currentYearSubscription.label}</small>;
                        default:
                            return <></>;
                    }
                })()}
            </td>
            <td className="previous-issue-usage">
                {previousIssueUsage ? <IssueUsageStatisticsCell {...previousIssueUsage} /> : null}
            </td>
            <td className="current-issue-usage">
                {currentIssueUsage ? <IssueUsageStatisticsCell {...currentIssueUsage} /> : null}
            </td>
            <td className="next-year-subscriptions">
                {(() => {
                    switch (nextYearSubscription.type) {
                        case ExtendedManageLineUsageLimit.Value:
                            return (
                                <ExtendedManageLineUsageLimitValue
                                    label={nextYearSubscription.label}
                                    stockDetails={nextYearSubscription.stockDetails}
                                />
                            );
                        case ExtendedManageLineUsageLimit.None:
                            return <small>{nextYearSubscription.label}</small>;
                        case ExtendedManageLineUsageLimit.NotRenewed:
                            return (
                                <div className="light">
                                    <MaterialIcon icon="shared" primary={false} className="shared-icon" />
                                    <small>{nextYearSubscription.label}</small>
                                </div>
                            );
                        default:
                            return <></>;
                    }
                })()}
            </td>
        </tr>
    );
};

const ExtendedManageLineUsageLimitValue: FC<{ label: string; stockDetails: StockDetails }> = ({
    label,
    stockDetails
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const [visible, setVisible] = useState(false);

    return (
        <>
            <div ref={ref} onMouseEnter={() => setVisible(true)} onMouseLeave={() => setVisible(false)}>
                <MaterialIcon icon="shared" primary={false} className="shared-icon" />
                <b>{label}</b>
            </div>
            <ProductCopyStockDropdown
                loanFormat={LOANFORMAT_EPRESS_OBJECT}
                stockDetails={stockDetails}
                placement="top-start"
                visible={visible}
                popoverRef={ref}
            />
        </>
    );
};
